<div
  style="
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 16px;
    overflow: hidden;
  "
>
  <!-- Header gradient: tasa + horario -->
  <div
    style="
      background: linear-gradient(135deg, #f0fdf4, #ecfdf5);
      padding: 14px 20px;
      border-bottom: 2px solid #bbf7d0;
      text-align: center;
    "
  >
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        margin-bottom: 6px;
      "
    >
      <img
        src="assets/icons/USDT_Logo.png"
        alt="USDT"
        style="width: 22px; height: 22px; border-radius: 50%; object-fit: cover"
      />
      <span style="font-size: 1.1rem; font-weight: 800; color: #1e5a3f"
        >1 USDT = {{ usdt_clp_tax | number: "1.0-2" }} CLP</span
      >
      <img
        src="assets/flags/chile.png"
        alt="CLP"
        style="width: 22px; height: 22px; border-radius: 50%; object-fit: cover"
      />
    </div>
    <!-- Tramos CLP→USDT: la mejor tasa publicada y el ahorro con este monto -->
    <!-- En el celular, con escalera, el «Desde X» vive en la escalera de
         abajo (la fila «Mejor»): acá no se repite para no bajar el botón. -->
    <p
      *ngIf="desdeTasa"
      class="tramo-desde"
      [class.tramo-desde--escalera]="!!escaleraClp"
      style="margin: 0 0 4px; font-size: 0.78rem; font-weight: 600; color: #166534; overflow-wrap: anywhere"
    >
      Desde {{ desdeTasa | number: "1.2-2" : "en-US" }} CLP por USDT según el monto
    </p>
    <p
      *ngIf="ahorroClp > 0 && !escaleraClp"
      class="tramo-ahorro"
      role="status"
      style="
        display: inline-block;
        max-width: 100%;
        overflow-wrap: anywhere;
        margin: 0 0 6px;
        padding: 2px 10px;
        border-radius: 999px;
        background: #dcfce7;
        font-size: 0.78rem;
        font-weight: 700;
        color: #166534;
      "
    >
      Con este monto ahorras ${{ ahorroClp | number: "1.0-0" : "en-US" }}
    </p>
    <span style="display: block; font-size: 0.75rem; font-weight: 600; color: #6b7280"
      >Horario de operacion: 4:00 - 23:00</span
    >
  </div>

  <div style="padding: 20px">
    <!-- Saldo row -->
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 16px;
        background: #f9fafb;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        margin-bottom: 16px;
      "
    >
      <div style="display: flex; align-items: center; gap: 6px">
        <mat-icon
          style="font-size: 18px; width: 18px; height: 18px; color: #1c593d"
          >account_balance_wallet</mat-icon
        >
        <span style="font-size: 0.8rem; font-weight: 600; color: #6b7280"
          >Saldo actual</span
        >
      </div>
      <span style="font-size: 1rem; font-weight: 700; color: #1e5a3f"
        >${{ saldoActual | currency: "" : "" : "1.0-0" }} CLP</span
      >
    </div>

    <!-- Línea de crédito info -->
    <div
      *ngIf="lineaCredito && lineaCredito > 0 && !lineaCreditoBloqueada"
      style="margin-bottom: 16px"
    >
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 8px 16px;
          background: #f9fafb;
          border: 1px solid #e5e7eb;
          border-radius: 10px;
          margin-bottom: 8px;
        "
      >
        <span style="font-size: 0.78rem; font-weight: 500; color: #6b7280"
          >Saldo contable</span
        >
        <span style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f"
          >${{ saldoContable | currency: "" : "" : "1.0-0" }} CLP</span
        >
      </div>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 8px 16px;
          background: #f9fafb;
          border: 1px solid #e5e7eb;
          border-radius: 10px;
        "
      >
        <span style="font-size: 0.78rem; font-weight: 500; color: #6b7280"
          >Sobregiro disponible</span
        >
        <span style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f"
          >${{ sobregiroDisponible | currency: "" : "" : "1.0-0" }} CLP</span
        >
      </div>
    </div>

    <!-- Error: línea bloqueada -->
    <div
      *ngIf="lineaCreditoBloqueada"
      style="
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 10px 14px;
        background: #fef2f2;
        border: 1px solid #fecaca;
        border-left: 4px solid #dc2626;
        border-radius: 10px;
        margin-bottom: 16px;
      "
    >
      <mat-icon
        style="
          font-size: 16px;
          width: 16px;
          height: 16px;
          flex-shrink: 0;
          color: #dc2626;
        "
        >error</mat-icon
      >
      <span style="font-size: 0.78rem; font-weight: 600; color: #991b1b"
        >Su línea de crédito se encuentra actualmente bloqueada</span
      >
    </div>

    <!-- Input CLP -->
    <div style="margin-bottom: 16px">
      <label
        style="
          display: block;
          font-size: 0.8rem;
          font-weight: 600;
          color: #1e5a3f;
          margin-bottom: 6px;
        "
        >Tú envías CLP</label
      >
      <div style="position: relative">
        <span
          style="
            position: absolute;
            left: 14px;
            top: 50%;
            transform: translateY(-50%);
            color: #1e5a3f;
            font-weight: 700;
            font-size: 0.82rem;
            pointer-events: none;
            z-index: 2;
          "
          >$ CLP</span
        >
        <input
          type="text"
          [(ngModel)]="valorClp"
          (keyup)="transformCurrency('clp')"
          (change)="emitAmountChange()"
          placeholder="0"
          pattern="[0-9]*"
          (keypress)="soloNumeros($event)"
          maxlength="10"
          class="calc-input"
          style="
            width: 100%;
            padding: 14px 100px 14px 72px;
            border: 2px solid #e5e7eb;
            border-radius: 12px;
            font-size: 1.1rem;
            font-weight: 700;
            color: #1e5a3f;
            background: white;
            text-align: right;
            outline: none;
            box-sizing: border-box;
            transition: border-color 0.2s;
          "
          onfocus="this.style.borderColor = '#34d399'"
          onblur="this.style.borderColor = '#e5e7eb'"
        />
        <span
          style="
            position: absolute;
            right: 8px;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            gap: 4px;
          "
        >
          <button
            *ngIf="valorClp !== ''"
            type="button"
            class="btn-tactil"
            (click)="clearValAvailableCLP()"
            style="
              background: #f3f4f6;
              color: #374151;
              border: none;
              border-radius: 8px;
              padding: 4px 8px;
              font-size: 0.8rem;
              font-weight: 600;
              cursor: pointer;
              transition: background 0.2s;
            "
            onmouseover="this.style.background = '#e5e7eb'"
            onmouseout="this.style.background = '#f3f4f6'"
          >
            ✕
          </button>
          <button
            type="button"
            class="btn-tactil"
            (click)="maxValAvailableCLP()"
            style="
              background: #1c593d;
              color: white;
              border: none;
              border-radius: 8px;
              padding: 4px 12px;
              font-size: 0.75rem;
              font-weight: 700;
              cursor: pointer;
              transition: background 0.2s;
            "
            onmouseover="this.style.background = '#059669'"
            onmouseout="this.style.background = '#1C593D'"
          >
            MÁX
          </button>
        </span>
      </div>
      <div
        *ngIf="lineaCredito === null && clpCurrency > saldoActual"
        style="
          display: flex;
          align-items: center;
          gap: 6px;
          margin-top: 6px;
          font-size: 0.75rem;
          font-weight: 600;
          color: #dc2626;
        "
      >
        <mat-icon
          style="font-size: 14px; width: 14px; height: 14px; color: #dc2626"
          >error_outline</mat-icon
        >
        El monto de envío excede el saldo actual
      </div>
      <div
        *ngIf="
          lineaCredito !== null &&
          lineaCredito! > 0 &&
          clpCurrency > saldoContable!
        "
        style="
          display: flex;
          align-items: center;
          gap: 6px;
          margin-top: 6px;
          font-size: 0.75rem;
          font-weight: 600;
          color: #dc2626;
        "
      >
        <mat-icon
          style="font-size: 14px; width: 14px; height: 14px; color: #dc2626"
          >error_outline</mat-icon
        >
        El monto de envío excede el saldo disponible
      </div>
    </div>

    <!-- Arrow divider -->
    <div style="display: flex; justify-content: center; margin-bottom: 12px">
      <div
        style="
          width: 36px;
          height: 36px;
          background: #1c593d;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <mat-icon
          style="font-size: 20px; width: 20px; height: 20px; color: white"
          >arrow_downward</mat-icon
        >
      </div>
    </div>

    <!-- Input USDT -->
    <div style="margin-bottom: 16px">
      <label
        style="
          display: block;
          font-size: 0.8rem;
          font-weight: 600;
          color: #1e5a3f;
          margin-bottom: 6px;
        "
        >Tu destinatario recibe USDT</label
      >
      <div style="position: relative">
        <span
          style="
            position: absolute;
            left: 14px;
            top: 50%;
            transform: translateY(-50%);
            color: #1e5a3f;
            font-weight: 700;
            font-size: 0.82rem;
            pointer-events: none;
            z-index: 2;
          "
          >$ USDT</span
        >
        <input
          type="text"
          [ngModel]="usdtDisplay"
          (ngModelChange)="onUsdtInput($event)"
          (focus)="onUsdtFocus()"
          (blur)="onUsdtBlur()"
          onfocus="this.style.borderColor = '#34d399'"
          onblur="this.style.borderColor = '#e5e7eb'"
          placeholder="0"
          (keypress)="soloNumerosDecimal($event)"
          maxlength="10"
          class="calc-input"
          style="
            width: 100%;
            padding: 14px 16px 14px 78px;
            border: 2px solid #e5e7eb;
            border-radius: 12px;
            font-size: 1.1rem;
            font-weight: 700;
            color: #1e5a3f;
            background: white;
            text-align: right;
            outline: none;
            box-sizing: border-box;
            transition: border-color 0.2s;
          "
        />
      </div>
      <div
        *ngIf="minError"
        style="
          display: flex;
          align-items: center;
          gap: 6px;
          margin-top: 6px;
          font-size: 0.75rem;
          font-weight: 600;
          color: #dc2626;
        "
      >
        <mat-icon
          style="font-size: 14px; width: 14px; height: 14px; color: #dc2626"
          >error_outline</mat-icon
        >
        El monto mínimo para enviar es de 20 USDT
      </div>
    </div>

    <!-- Escalera de tramos: «Tu tasa» (la que se cobra, con segmentación),
         «Tramo k de N», el ahorro, lo que falta y la lista plegada. Sin
         escalera no se dibuja y la pantalla queda como antes. En el celular
         acá va solo el teaser de una línea; la completa, debajo del botón.
         Formato en-US, el del campo de monto. -->
    <app-escalera-tramos
      *ngIf="usdt_clp_tax > 0 && escaleraClp"
      class="calc-escalera"
      posicion="arriba"
      locale="en-US"
      [escalera]="escaleraClp"
      [monto]="clpCurrency"
      moneda="CLP"
      monedaDestino="USDT"
      tipoAhorro="PAGA_MENOS"
      decimales="1.2-2"
      [base]="baseTramos"
      [precioCorte]="precioCorteTramos"
      [tasaAplicada]="usdt_clp_tax"
      [tasaReferencia]="baseTramos"
      simbolo="CLP"
      unidad="CLP por 1 USDT"
      idBase="esc-clp-usdt"
      [compacta]="true"
      [permitirUsar]="!lineaCreditoBloqueada"
      [montoMaximo]="maximoClp"
      (usarMonto)="usarMontoClp($event)"
    ></app-escalera-tramos>
  </div>
</div>

<!-- Buy button (fuera de la card para sticky móvil) -->
<div class="step-actions">
  <button
    type="button"
    (click)="emitChangeStep()"
    [disabled]="
      clpCurrency === 0 ||
      usdtCurrency === 0 ||
      minError ||
      (lineaCredito === null && clpCurrency > saldoActual) ||
      (lineaCredito! > 0 && clpCurrency > saldoContable!) ||
      lineaCreditoBloqueada
    "
    [style.opacity]="
      clpCurrency === 0 || usdtCurrency === 0 || minError ? '0.5' : '1'
    "
    [style.cursor]="
      clpCurrency === 0 || usdtCurrency === 0 || minError
        ? 'not-allowed'
        : 'pointer'
    "
    style="
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      padding: 14px;
      background: #1c593d;
      color: white;
      border: none;
      border-radius: 10px;
      font-weight: 700;
      font-size: 0.95rem;
      cursor: pointer;
      transition: background 0.2s;
    "
    onmouseover="if (!this.disabled) this.style.background = '#059669';"
    onmouseout="this.style.background = '#1C593D'"
  >
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white"
      >shopping_cart</mat-icon
    >
    Comprar
  </button>
</div>

<!-- Celular (bajo 768 px): la escalera completa, debajo del botón. -->
<app-escalera-tramos
  *ngIf="usdt_clp_tax > 0 && escaleraClp"
  class="calc-escalera"
  posicion="abajo"
  locale="en-US"
  [escalera]="escaleraClp"
  [monto]="clpCurrency"
  moneda="CLP"
  monedaDestino="USDT"
  tipoAhorro="PAGA_MENOS"
  decimales="1.2-2"
  [base]="baseTramos"
  [precioCorte]="precioCorteTramos"
  [tasaAplicada]="usdt_clp_tax"
  [tasaReferencia]="baseTramos"
  simbolo="CLP"
  unidad="CLP por 1 USDT"
  idBase="esc-clp-usdt"
  [compacta]="true"
  [permitirUsar]="!lineaCreditoBloqueada"
  [montoMaximo]="maximoClp"
  (usarMonto)="usarMontoClp($event)"
></app-escalera-tramos>
